module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sysmanagement-privilege"
  }, [_c('div', {
    staticClass: "page-submenu"
  }, [_c('div', {
    staticClass: "page-submenu_left"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('left-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-submenu_right"
  }, [_c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "search-content"
  }, [_c('div', {
    staticClass: "search-content-fields"
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "员工ID"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入员工ID"
    },
    model: {
      value: (_vm.searchData.username),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "username", $$v)
      },
      expression: "searchData.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.searchData.realname),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "realname", $$v)
      },
      expression: "searchData.realname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "部门"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.departIds),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "departIds", $$v)
      },
      expression: "searchData.departIds"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在治疗领域（franchise）"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.searchData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.searchData, "medicalField", $$v)
      },
      expression: "searchData.medicalField"
    }
  }, _vm._l((_vm.baseDataRecords.MedicalField), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearch()
      }
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handlerExportExcelClick()
      }
    }
  }, [_vm._v("批量导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleAddNewClick()
      }
    }
  }, [_vm._v("新增用户")])], 1)]), _vm._v(" "), _c('common-crud', {
    ref: "crud",
    attrs: {
      "addNewOrEditData": _vm.addNewOrEditData,
      "searchData": _vm.searchData,
      "searchDataLikeField": {
        'username': '*',
        'realname': '*',
        'roleIds': '*',
        'departIds': '*'
      },
      "crudApi": _vm.crudApi,
      "tableData": _vm.privilegeData,
      "showEditFormTitle": false,
      "beforeSave": _vm.beforeSave,
      "editDialogClass": "sys-privilege-edit-dialog",
      "selectedDataArray": _vm.selectedData,
      "addSuccessMessages": "新增用户成功",
      "editSuccessMessages": "编辑用户成功",
      "deleteSuccessMessages": "删除用户成功"
    },
    on: {
      "update:tableData": function($event) {
        _vm.privilegeData = $event
      },
      "update:table-data": function($event) {
        _vm.privilegeData = $event
      },
      "update:selectedDataArray": function($event) {
        _vm.selectedData = $event
      },
      "update:selected-data-array": function($event) {
        _vm.selectedData = $event
      }
    }
  }, [_c('template', {
    slot: "result"
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "width": "60",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "username",
      "label": "员工ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "realname",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "departIds",
      "label": "部门"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "prop": "medicalField",
      "width": "135"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "display": "inline-block"
          }
        }, [_c('div', [_vm._v("所在治疗领域")]), _vm._v(" "), _c('div', [_vm._v("（franchise）")])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-column-operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleEditClick(scope.row)
            }
          }
        }, [_vm._v("\n                    编辑\n                  ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.handleDeleteClick(scope.row)
            }
          }
        }, [_vm._v("\n                    删除\n                  ")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('template', {
    slot: "customTitle"
  }, [_vm._v(_vm._s(_vm.actionType == 'add' ? '新增用户' : '用户信息'))]), _vm._v(" "), _c('template', {
    slot: "editForm"
  }, [(_vm.actionType == 'add') ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "搜索AD账号"
    },
    model: {
      value: (_vm.adSearchText),
      callback: function($$v) {
        _vm.adSearchText = $$v
      },
      expression: "adSearchText"
    }
  }, [_c('el-button', {
    staticClass: "ad-search",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        return _vm.handleSearchAD()
      }
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "员工ID",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.username),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "username", $$v)
      },
      expression: "addNewOrEditData.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "realname"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.realname),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "realname", $$v)
      },
      expression: "addNewOrEditData.realname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "部门",
      "prop": "departIds"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.departIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "departIds", $$v)
      },
      expression: "addNewOrEditData.departIds"
    }
  }, _vm._l((_vm.baseDataRecords.Depart), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', [_c('el-form-item', {
    attrs: {
      "label": "所在治疗领域（franchise）",
      "prop": "medicalField"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "multiple": "",
      "placeholder": "搜索AD账号系统自动查询"
    },
    model: {
      value: (_vm.addNewOrEditData.medicalField),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "medicalField", $$v)
      },
      expression: "addNewOrEditData.medicalField"
    }
  }, _vm._l((_vm.baseDataRecords.MedicalField), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.medicalFieldName
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-form-item', {
    attrs: {
      "prop": "allowDepartIds"
    }
  }, [_c('span', {
    staticClass: "tooltip-header-text",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("允许查看部门数据"), _c('common-tooltip', {
    attrs: {
      "tipCode": "13"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择（可多选）"
    },
    model: {
      value: (_vm.addNewOrEditData.allowDepartIds),
      callback: function($$v) {
        _vm.$set(_vm.addNewOrEditData, "allowDepartIds", $$v)
      },
      expression: "addNewOrEditData.allowDepartIds"
    }
  }, _vm._l((_vm.allowDeparts), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.departName
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "confirmAddNewMessage"
  }, [_c('div', [_c('span', [_vm._v("确认添加该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmEditMessage"
  }, [_c('div', [_c('span', [_vm._v("确认保存该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("删除该用户？")])])]), _vm._v(" "), _c('template', {
    slot: "confirmBatchDeleteMessage"
  }, [_c('div', [_c('span', [_vm._v("批量删除用户？")])])])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-81adb67a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81adb67a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/sysmanagement/privilege/index.vue
// module id = 1593
// module chunks = 7